const dismissalKey = (graceDeadline: string): string => `mfaEnforcementBanner.dismissed.${graceDeadline}`;

const isDismissed = (graceDeadline: string): boolean => {
	try {
		return sessionStorage.getItem(dismissalKey(graceDeadline)) === "true";
	} catch {
		return false;
	}
};

const markDismissed = (graceDeadline: string): void => {
	try {
		sessionStorage.setItem(dismissalKey(graceDeadline), "true");
	} catch {
		// sessionStorage can be unavailable in private mode
	}
};

const mfaBannerDismissal = { isDismissed, markDismissed };

export default mfaBannerDismissal;
